var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from '../elements/svg-circle-icon';
export var EmptyFilledIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 65,
    glyphHeight: 65
  }), React.createElement("path", {
    d: "M32.0142 64.5142C49.6873 64.5142 64.0142 50.1873 64.0142 32.5142C64.0142 14.841 49.6873 0.51416 32.0142 0.51416C14.341 0.51416 0.0141602 14.841 0.0141602 32.5142C0.0141602 50.1873 14.341 64.5142 32.0142 64.5142ZM50.2774 51.8731L12.655 14.2507L13.7506 13.1551L21.1309 20.5353C24.0282 17.7953 27.9382 16.1152 32.2407 16.1152C41.1722 16.1152 48.4127 23.3556 48.4127 32.2872C48.4127 36.5897 46.7325 40.4997 43.9926 43.397L51.373 50.7775L50.2774 51.8731ZM32.2407 17.6646C28.3661 17.6646 24.8434 19.1716 22.2269 21.6314L42.8965 42.301C45.3563 39.6844 46.8633 36.1618 46.8633 32.2872C46.8633 24.2114 40.3165 17.6646 32.2407 17.6646ZM40.6327 44.2634C38.2574 45.931 35.3633 46.9098 32.2407 46.9098C24.1649 46.9098 17.6181 40.363 17.6181 32.2872C17.6181 29.1646 18.5969 26.2705 20.2644 23.8952L19.1537 22.7845C17.2133 25.4522 16.0687 28.736 16.0687 32.2872C16.0687 41.2188 23.3091 48.4592 32.2407 48.4592C35.7919 48.4592 39.0757 47.3146 41.7434 45.3742L40.6327 44.2634Z"
  }));
};
export var EmptyFilledIconGlyph = function (props) {
  return React.createElement(EmptyFilledIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};